module.exports = __webpack_public_path__ + "static/Landi-6e6ac04a318f2fb425ea0ceb87d630d9.png";